import React from 'react';

function Cases() {
  const images = [
    '/home1/assets/img/slider/head_slide10.jpg',
    '/home1/assets/img/slider/2.jpg',
    '/home1/assets/img/slider/slideimg.jpg',
    '/home1/assets/img/slider/4.jpg',
    '/home1/assets/img/slider/5.jpg',
    '/home1/assets/img/slider/head_slide7.jpg',
    '/home1/assets/img/slider/head_slide8.jpg.jpg',
    '/home1/assets/img/slider/head_slide9.jpg',
    '/home1/assets/img/slider/Sauna.jpg',
    
    
  ];
//irina
  return (
    <section className="tc-cases-style10 section-padding-x" style={{ paddingTop: '30px', paddingBottom: '100px' }}>
      <div className="container-fluid">
        <div className="cases-content">
          <div className="row">
            {images.map((src, i) => (
              <div key={i} className={`col-12 col-md-6 col-lg-${i === 2 ? '12' : '6'} mb-4`}>
                <div className={`case-item ${i === 2 ? 'th-600' : ''} wow left_to_right_apperance no_scale d-none d-lg-block`}>
                  <div className="img">
                    <img src={src} alt={`gallery-${i}`} className="img-cover rounded" />
                  </div>
                </div>
                <div className={`case-item ${i === 2 ? 'th-600' : ''} d-block d-lg-none`}>
                  <div className="img">
                    <img src={src} alt={`gallery-${i}`} className="img-cover rounded" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Cases;
